import { useTranslation } from 'react-i18next';
import { useGateHold } from '@/features/authGate/useGateHold';

// A Suspense fallback must never suspend itself. On a cold load the first render runs before
// i18next has finished init, and a <Redirect> navigates synchronously (wouter's location store
// is a sync update) into a lazy page that is not loaded yet. If this fallback suspended too, the
// suspension would bubble past every boundary to the root and React would throw #426 (blank page).
export function LoadingFallback() {
  const { t } = useTranslation('common', { useSuspense: false });
  // while the auth gate is up, a screen that is still loading behind it keeps it up (nothing else here changes)
  useGateHold(true);
  return (
    <div role="status" aria-live="polite" className="flex items-center justify-center min-h-screen">
      {t('loading', 'Loading...')}
    </div>
  );
}
